import 'css-chunksrc/client/scenes/projectResourceRemoval/resource/styles.scss';export default {
  "resource": "_resource_1nlul_1",
  "user": "_user_1nlul_8",
  "avatar": "_avatar_1nlul_20",
  "name": "_name_1nlul_30",
  "title": "_title_1nlul_35"
};